import { withAsyncLoading } from '../../../lib/PST.Web.Common/src/hocs/withAsyncPageLoading/withAsyncPageLoading';

const LoadableFormationDetailsSatisfactionSurveyPage = withAsyncLoading(async () => import('./FormationDetailsSatisfactionSurveyPage').then((res) => res.FormationDetailsSatisfactionSurveyPage));

export { LoadableFormationDetailsSatisfactionSurveyPage };
